import { storyblokEditable } from "@storyblok/react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { ArrowRight } from "lucide-react";

const Solutions = ({ blok }) => {
  return (
    <section
      {...storyblokEditable(blok)}
      className="solutions font-display text-left"
    >
      <small>How Catalyst can help</small>
      <h2>Solutions for your nonprofit</h2>
      <Tabs>
        <TabList>
          <Tab>Your Peer-to-peer program </Tab>
          <Tab>Personal Peer-to-peer fundraising</Tab>
          <Tab>Fitness fundraising</Tab>
        </TabList>
        <TabPanel>
          <div className="tab-container">
            <div className="tab-left">
              <h3>Supercharge your impact!</h3>
              <p>
                When nonprofits actively fuel their fundraisers, volunteers
                don't just participate—they ignite results! Event-connected
                fundraisers outperform by a powerful 37%, turning passion into
                measurable momentum. Tiltify Catalyst doesn't just support your
                team—it launches them toward breakthrough success!
              </p>
              <a
                className="button button-primary"
                href="/solutions/peer-to-peer-events"
              >
                Ignite your fundraising{" "}
                <ArrowRight size={24} fill="white" className="button-icon" />
              </a>
            </div>
            <div className="tab-right">
              <img
                src="https://a.storyblok.com/f/341980/1599x962/7c4102d6ec/hug-shapes.jpeg?"
                alt="Two ladies dressed in pink hugging having finished a breast cancer awareness race"
              />
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="tab-container">
            <div className="tab-left">
              <h3>Don't keep your fundraisers in a box</h3>
              <p>
                Catalyst from Tiltify revolutionizes fundraising by putting
                creative power directly in supporters' hands — no more
                cookie-cutter campaigns.
                <br />
                <br />
                Your volunteers build authentic fundraisers that reflect their
                passion while your nonprofit provides the guidance that
                transforms their enthusiasm into impressive results.
                <br />
                <br />
                Social media, videos, podcasts, fitness, selling items, or
                anything else, Tiltify gives them the tools to fundraise their
                way.
                <br />
                <br />
                When supporters feel empowered to create, they don't just raise
                money, they build movements.
              </p>
              <a
                className="button button-primary"
                href="/solutions/peer-to-peer-fundraising"
              >
                Open the box{" "}
                <ArrowRight size={24} fill="white" className="button-icon" />
              </a>
            </div>
            <div className="tab-right">
              <img
                src="https://a.storyblok.com/f/341980/1599x962/46ee745839/bakesale-shapes.jpeg"
                alt="Photo of a bake sale with tasty chocolate cupcakes, and red velvet cakes in the foreground with people blurred in the background. Probably eating all the cakes"
              />
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="tab-container">
            <div className="tab-left">
              <h3>Mission &gt; Movement &gt; Money Raised</h3>
              <p>
                Tiltify Catalyst energizes fundraising with engagement tools
                that turn passion into impact. Activity tracking, milestones,
                livestream features and more, keep supporters fired up while
                keeping your mission at the heart of every campaign.
              </p>
              <a
                className="button button-primary"
                href="/solutions/fitness-fundraising"
              >
                Get off the starting block{" "}
                <ArrowRight size={24} fill="white" className="button-icon" />
              </a>
            </div>
            <div className="tab-right">
              <img
                src="https://a.storyblok.com/f/341980/1600x955/d9b739ed33/people-running-in-a-long-distance-road-race.jpeg"
                alt="A group of runners running a road race"
              />
            </div>
          </div>
        </TabPanel>
      </Tabs>
    </section>
  );
};

export default Solutions;
